<template>
  <div class="item-container">
    <template v-if="printStatus === 'FAILED'">
      <h2 class="center">
        {{ $t('tcm.prescription') }}
        {{ $t('pharmacy.nothingMessage') }}
      </h2>
    </template>
    <template v-else-if="printStatus === 'PRINTED'">
      <div class="prescription" v-for="(prescription, index) in consultation.order" :key="index">
        <div class="prescription-container" v-if="hasMedicineToPrint(prescription)">
          <div class="row mb-3">
            <div class="col-7">
              <img class="mb-4" style="width: 520px; height: 150px; margin-left: 0" :src="generalConfig.logoURL">
            </div>
            <div class="col-5">
              <h2 class="mb-5 mt-3 text-center text-uppercase">
                {{ $t('tcm.consultationPrescription.title') }} {{ index + 1 }}
              </h2>
            </div>
          </div>
          <div class="row mb-4 ps-header">
            <div class="col-6">
              <div class="row">
                <div class="col-4 text-uppercase form-label">{{ $t('tcm.consultationPrescription.dateOfPrint') }}:</div>
                <div class="col-4 border-bottom border-dark">{{ printDate }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-4 text-uppercase form-label">{{ $t('general.visitBranch') }}:</div>
                <div class="col border-bottom border-dark">{{ visitBranch }}</div>
              </div>
            </div>
          </div>
          <div class="ps-content">
            <div class="row patient-info">
              <div class="col-4 mb-1 patient-name">
                <div class="row">
                  <div class="col-7">
                    <span class="">{{ $t('tcm.consultationPrescription.gender') }}</span>
                    <span class="font-weight-bold">({{ $t('tcm.consultationPrescription.name') }})</span>
                  </div>
                  <div class="col border-bottom border-dark text-center">
                    <span> {{ consultation.patient.name }}</span>
                  </div>
                </div>
              </div>
              <div class="col-4 mb-1">
                <div class="row">
                  <div class="col-3">
                    <span class="font-weight-bold">/({{ $t('general.nric') }})</span>
                  </div>
                  <div class="col border-bottom border-dark text-center">
                    <span> {{ consultation.patient.nric }}</span>
                  </div>
                </div>
              </div>
              <div class="col-4 mb-1">
                <div class="row">
                  <div class="col-4">
                    <span class="font-weight-bold">/({{ $t('tcm.consultationPrescription.dob') }})</span>
                  </div>
                  <div class="col border-bottom border-dark text-center">
                    <span> {{ dob }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row signature-line"></div>
            <div class="row mb-2">
              <div class="col">
                <span>has been prescribed the following herbal medication on </span>
                <span class="border-bottom border-dark">{{ visitDate }} </span>
                <span>(Date of Prescription):</span>
              </div>
            </div>
            <div class="row mb-4"></div>
            <div class="mb-6 medicine-items">
              <div class="row med-header-en">
                <div class="col-1 text-uppercase" v-if="printWithDailyDosage">{{ $t('tcm.consultationPrescription.code') }}</div>
                <div class="col text-uppercase" v-if="!printWithDailyDosage">{{ $t('tcm.consultationPrescription.code') }}</div>
                <div class="col text-uppercase">{{ $t('tcm.consultationPrescription.medicineChinese') }}</div>
                <div class="col text-uppercase">{{ $t('tcm.consultationPrescription.medicine') }}</div>
                <div class="col text-uppercase" v-if="printWithDailyDosage">{{
                  $t('tcm.consultationPrescription.totalDosage') }}</div>
                <div class="col text-uppercase" v-if="printWithDailyDosage">{{
                  $t('tcm.consultationPrescription.dailyDosage') }}</div>

                <div class="col text-uppercase">{{ $t('tcm.consultationPrescription.note') }}</div>
              </div>

              <div class="row med-body" v-for="item in medicinesToPrint(prescription)" :key="item._id">
                <div class="col-1" v-if="printWithDailyDosage">{{ item.givenId }}</div>
                <div class="col" v-if="!printWithDailyDosage">{{ item.givenId }}</div>
                <div class="col">{{ item.name }}</div>
                <div class="col">{{ item.chineseName || '' }}</div>
                <div class="col" v-if="printWithDailyDosage">
                  <span v-if="dailyDosageCategorySet.has(item.category)">
                    {{
                      calTotalDosage({
                        dosage: item.qty || 0,
                        totalDays: prescription.totalDays || 1,
                        ratio: prescription.dilutionRatio || 1,
                      })
                    }}
                  </span>
                  <span v-else>{{ item.qty }}</span>
                  {{ item.unit }}
                </div>
                <div class="col" v-if="printWithDailyDosage">{{ item.qty }} {{ item.unit }}</div>
                <div class="col">{{ item.remarks }}</div>
              </div>
            </div>

            <div class="mb-4 row">
              <div class="col">
                <span>
                  *This prescription should be consumed under the advice of a licensed TCM physician. Ma Kuang does not
                  encourage the purchase
                  of this herbal prescription from external sources other than our clinics.
                </span>
              </div>
            </div>

            <div class="mb-5 row">
              <div class="col form-label">
                <div class="row mb-1">
                  <div class="col-2 form-label">{{ $t('tcm.consultationPrescription.remarks') }}:</div>
                  <div class="col">{{ prescriptionRemarks(prescription) }}
                  </div>
                </div>
              </div>
            </div>

            <div class="mb row med-footer">
              <div class="col form-label">
                <div class="row mb-1">
                  <div class="col-2 form-label">{{ $t('tcm.consultationPrescription.signatureTcmPhysician') }}</div>
                  <div class="col"> {{ showAttendedBy }}
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="page-break" v-if="index !== (withItemsOrders.length - 1)"></div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import currency from 'currency.js'
import moneyFormatter from '@/components/mixins/money';
import dateformatter from '@/components/mixins/dateformatter';
import constant from '@/services/constant';

const { PRINT_STATUS } = constant;

export default {
  name: 'ConsultationPrescriptionRecord',
  mixins: [moneyFormatter, dateformatter],
  props: {
    consultation: {
      type: Object,
      default: () => ({}),
    },
    printWithDailyDosage: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: PRINT_STATUS.PRINTING,
    },
  },
  data() {
    return {
      printDate: moment().format('DD/MM/YY'),
    };
  },
  computed: {
    ...mapGetters('config', {
      generalConfig: 'general',
      inventoryConfig: 'inventory',
    }),
    visitDate() {
      return this.consultation && moment(this.consultation.visitDate).format('DD/MM/YY');
    },
    dob() {
      const dob = this.consultation && this.consultation.patient && this.consultation.patient.dateOfBirth;
      if (dob) {
        return moment(dob).format('DD/MM/YY');
      }
      return '';
    },
    visitBranch() {
      const makuang = 'MAKUANG';
      const clinicName = this.consultation && this.consultation.clinic && this.consultation.clinic.name;
      if (clinicName) {
        return `${makuang}@${clinicName.split('-')[1]}`;
      }
      return makuang;
    },
    showAttendedBy() {
      return (this.consultation && this.consultation.doctor && this.consultation.doctor.name)
        || (this.consultation && this.consultation.queue && this.consultation.queue.therapist && this.consultation.queue.therapist.name);
    },
    printStatus() {
      return this.status;
    },
    withItemsOrders() {
      const result = this.consultation.order.filter(prescription => this.hasMedicineToPrint(prescription));
      return result;
    },
    dailyDosageCategorySet() {
      const {
        powderMedicineCategories = '',
        herbalMedicineCategories = '',
        patentMedicineCategories = '',
      } = this.inventoryConfig;
      return new Set(
        powderMedicineCategories
          .split(',')
          .concat(herbalMedicineCategories.split(','))
          .concat(patentMedicineCategories.split(','))
          .filter(item => typeof item === 'string' && item.trim().length !== 0),
      );
    },
  },
  methods: {
    statusPrinted() {
      return PRINT_STATUS.PRINTED;
    },
    statusFailed() {
      return PRINT_STATUS.FAILED;
    },
    hasMedicineToPrint(prescription) {
      return prescription.items.filter(item => this.printPrescriptionCategories().includes(item.category)).length > 0;
    },
    medicinesToPrint(prescription) {
      const data = prescription.items.filter(item => this.printPrescriptionCategories().includes(item.category));
      return data;
    },
    prescriptionRemarks(prescription) {
      return prescription.remarks || '';
    },
    printPrescriptionCategories() {
      const { printPrescriptionCategories = '' } = this.inventoryConfig;
      return printPrescriptionCategories.split(',').filter(category => typeof category === 'string' && category.length !== 0);
    },
    calTotalDosage({ dosage, totalDays, ratio }) {
      return currency(dosage).multiply(totalDays).multiply(ratio / totalDays).value;
    },
  },
};
</script>

<style lang="scss" scoped>
.classified-medicine-tip {
  font-size: 20px;
  font-weight: bold;
  margin-top: 40px;
}

.medicine-items {
  margin: 3rem 1rem;
}

.item-container {
  padding: 1rem 1rem;
}

.clinic-name {
  margin-top: 10px;
}

.patient-name {
  padding-left: 0;
}
.clinic-address {
  font-weight: bold;
  margin-top: 10px;
}

.form-label {
  font-weight: bold;
}

.medicine-content-title {
  font-size: 20px;
  font-weight: bold;
}

.med-header-en {
  font-weight: bold;
  padding: 10px 0;
  // border-width: 2px 0 0 0;
  // border-style: solid;
  // border-color: #333;
  margin-left: 0;
  margin-right: 0;
}

.prescription-container {
  border-width: 2px 0 0 0;
  border-style: solid;
  border-color: #333;
}

.signature-line {
  font-weight: bold;
  padding: 10px 0;
  border-width: 1.5px 0 0 0;
  border-style: solid;
  border-color: #333;
  margin-left: 0;
  margin-right: 0%;
  // padding: 0;
}

.ps-content {
  border-width: 3px;
  border-style: solid;
  border-color: #333;
  padding: 0.5rem;
}

.patient-info {
  margin-top: 1%;
  margin-right: 0;
  margin-left: 0;
}

.ps-header {
  margin-right: 0;
  margin-left: 0;
}

.med-header-cn {
  font-weight: bold;
  padding: 10px 0;
  border-width: 0 0 2px 0;
  border-style: solid;
  border-color: #333;
  margin-left: 0;
  margin-right: 0;
}

.med-body {
  padding: 10px 0;
  border-bottom: 1px solid #333;
  margin-left: 0;
  margin-right: 0;
}

.dividing-wrap {
  font-weight: bold;
  padding-top: 10px;
  border-top: 2px solid #333;
  margin-top: 30px;
}

.page-break {
  page-break-after: always;
}

.med-footer {
  display: flex;
  align-items: flex-start;
}</style>
